var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table class="table table-condensed table-striped"> <thead> <tr> <th>&nbsp;</th> <th>Month</th> <th>Remaining Balance</th> <th>Monthly Interest</th> <th>Total Interest</th> </tr> </thead> <tbody class="month-results"> </tbody> </table>';
}
return __p;
};
